/* Words for a sale or a purchase, as a business says them (PK-65). */
import type { FlowDoc, FlowStage } from './types'

/** What a document is called, returns included: a returned invoice is a credit note. */
export function docWord(doctype: string, isReturn = false): string {
  switch (doctype) {
    case 'Quotation': return 'Quote'
    case 'Sales Order': return 'Order'
    case 'Delivery Note': return isReturn ? 'Goods returned' : 'Delivery'
    case 'Sales Invoice': return isReturn ? 'Credit note' : 'Invoice'
    case 'Purchase Order': return 'Purchase order'
    case 'Purchase Receipt': return isReturn ? 'Sent back to supplier' : 'Goods received'
    case 'Purchase Invoice': return isReturn ? 'Debit note' : 'Bill'
    case 'Payment Entry': return 'Payment'
    default: return doctype
  }
}

/** A stage's state in words. */
export function stageWord(state: FlowStage['state']): string {
  return { done: 'Done', part: 'Part paid', draft: 'Draft', todo: 'To do', skipped: 'Not needed' }[state]
}

/** What a document in the chain is worth: its total, or for a payment what was paid. */
export function amountOf(doc: FlowDoc): number | null {
  const v = doc.grand_total ?? doc.paid_amount
  return typeof v === 'number' ? v : null
}

/** The doctypes this view shows (a sale or a purchase); anything else opens as a form. */
export const FLOW_DOCTYPES = new Set([
  'Quotation', 'Sales Order', 'Delivery Note', 'Sales Invoice',
  'Purchase Order', 'Purchase Receipt', 'Purchase Invoice', 'Payment Entry',
])
